var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketingProjectContent" }, [
    _c("div", { ref: "topIframe", staticClass: "topIframe" }, [
      _c("iframe", {
        attrs: {
          width: "100%",
          height: "100%",
          src: _vm.topIframeUrl,
          frameborder: "0"
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "new_sidebar" }, [
      _c(
        "div",
        { staticClass: "tree" },
        [
          _c("div", { staticClass: "new_sidebar_head" }, [_vm._v("资料箱")]),
          _vm._v(" "),
          _vm._l(_vm.subjectTrees, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "treeItem" },
              [
                _c("el-tree", {
                  ref: "tree",
                  refInFor: true,
                  style: { height: "300px" },
                  attrs: {
                    data: item,
                    "node-key": "id",
                    props: _vm.defaultProps,
                    "highlight-current": true,
                    "default-expanded-keys": [_vm.defaultExpansion]
                  },
                  on: { "node-click": _vm.handleNodeClick },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var data = ref.data
                          return _c(
                            "div",
                            { staticClass: "custom-tree-node" },
                            [
                              data.id && data.status != 1
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "custom-tree-node-label",
                                      attrs: { title: data.catalogName }
                                    },
                                    [_vm._v(_vm._s(data.catalogName))]
                                  )
                                : _vm._e()
                            ]
                          )
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.documentObj } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n            " +
                            _vm._s(scope.$index) +
                            "\n          "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "resourceName", label: "资料名称" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.deleteRow(
                                  scope.$index,
                                  _vm.documentObj
                                )
                              }
                            }
                          },
                          [_vm._v("\n              移除\n            ")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49cf7f75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49cf7f75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auditNewRealTask/components/officeArea.vue
// module id = null
// module chunks = 